module.exports = __webpack_public_path__ + "static/grafika8-aee44f42a585b94e4cd6aa89c1be736a.png";